export const CommonActionType = {
    SetExchangeRate: '[Common] Set Exchange Rate',
    SetMinFeeBuy: '[Common] Set Min FeeBuy',
    FeeBuyPro: '[Common] Set Fee Buy Pro',
    SetCustomerLevels: '[Common] Set Customer Levels',
    SetWarehouse: '[Common] Set Warehouse',
    SetShippingMethod: '[Common] Set Shipping Method',
    ShowHideMenuLeft: '[Common] Show hide menu left'
};

